export const skeletonBlocks = ['widget', 'checkout', 'popup']

export const skeletonFields = ['first', 'second', 'third']
